import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import DataTable from "@/components/dataTable";
import DateSelection from "@/components/dateSelection";
import { TransferInvoiceTableColumn } from "@/config/tableColumnConfig";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "../styles/mui/globalStyles";
import { InputTheme, TableListTheme } from "../styles/mui/tableListTheme";
// Mui
import CreateTransferInvoiceDialog from "@/components/Dialog/createTransferInvoiceDialog";
import Grid from "@mui/material/Grid2";

//lodash

// Navigate
import { useLocation, useNavigate } from "react-router-dom";

// Components
import { useSelector } from "react-redux";
import Layout from "../components/layout";
import Title from "../components/title";
// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import { useCurrentAction } from "@/hooks/user";
import { getTransferInvoice } from "../fetch/fetchStock";

// create  a header for csv library

const TransferInvoicePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();

  const { pathname } = location;
  // States
  const defaultStartDate = moment().startOf("month");
  const defaultEndDate = moment().endOf("month");

  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  // States
  const [selectedShop, setSelectedShop] = React.useState(0);
  const [rowsData, setRowsData] = React.useState([]);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  // Fetch

  const fetchTransferInvoice = async (selectedShop, startDate, endDate) => {
    try {
      setDataTableLoading(true);
      await getTransferInvoice(selectedShop, startDate, endDate).then(
        (data) => {
          if (data && data.results) {
            setRowsData(data.data);
          } else {
            setRowsData([]);
          }
        }
      );
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  const fetchAll = async () => {
    await fetchTransferInvoice(
      selectedShop,
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
  };
  const onCellClick = (data) => {
    navigate(`/transferInvoice/${data.row.invoice_id}`);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedShop, startDate, endDate]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });
  const getRowId = (row) => {
    return row.invoice_id;
  };
  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={24}
      snackOpen={snackOpen}
      // snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        FunctionOn={actions?.create}
        title={`調貨清單`}
        history={() => navigate(-1)}
        onClickCreate={() => setIsDialogOpen((prev) => !prev)}
      />
      <StyledPaper page={"yes"} alignItems="left">
        <Grid container spacing={2}>
          <ThemeProvider theme={InputTheme}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            ></DateSelection>
          </ThemeProvider>
        </Grid>
      </StyledPaper>
      <CreateTransferInvoiceDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen((prev) => !prev)}
        // datetime={datetime}
        setSnackSeverity={setSnackSeverity}
        setSnackOpen={setSnackOpen}
        setSnackMessage={setSnackMessage}
        fetchAll={fetchAll}
        // productData={productData}
      ></CreateTransferInvoiceDialog>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={rowsData}
            columns={TransferInvoiceTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            getRowId={getRowId}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};
export default TransferInvoicePage;
